import { render, staticRenderFns } from "./MasterUI.vue?vue&type=template&id=2f8ef426"
import script from "./MasterUI.vue?vue&type=script&lang=js"
export * from "./MasterUI.vue?vue&type=script&lang=js"
import style0 from "./MasterUI.vue?vue&type=style&index=0&id=2f8ef426&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports